import { render, staticRenderFns } from "./AutoAssignDialog.vue?vue&type=template&id=3b03dd22"
import script from "./AutoAssignDialog.vue?vue&type=script&lang=js"
export * from "./AutoAssignDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports